import React from 'react';
import BaseApi from '../../../api/BaseApi.js';
import ScreenCaption from '../../screen-caption.js';


export default class EventTypeScreen extends React.Component {

    constructor(props) {
        super(props);

        this.state = {currentEventType: {id: null, 
                                        name: "", 
                                        description: ""}};

        this.handleChangeName = this.handleChangeName.bind(this);  
        this.handleChangeDescription = this.handleChangeDescription.bind(this); 
        this.save = this.save.bind(this);                         
    }

    async componentDidMount() {

        if (this.props.args.event_type && this.props.args.event_type.length > 0) {
            BaseApi.get("/event/type", {headers: {
                'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: {id: this.props.args.event_type}, withCredentials: true})
            .then(res => { 
                this.setState({currentEventType: res.data})
            })    
            .catch()
        }
    }


    save(event) {
        BaseApi.post('/event/type', this.state.currentEventType, {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => {
            var currentEventType = this.state.currentEventType
            currentEventType.id = res.data.id
            this.setState({currentEventType: currentEventType})
            this.props.args.event_type = res.data.id
        })
        .catch(error=>console.log(error))
        
        event.preventDefault();
    }

    handleChangeName(event) {
        var currentEventType = this.state.currentEventType
        currentEventType.name = event.target.value
        this.setState({currentEventType: currentEventType})
    }

    handleChangeDescription(event) {
        var currentEventType = this.state.currentEventType
        currentEventType.description = event.target.value
        this.setState({currentEventType: currentEventType})
    }

    render() {
    
        return (
            <div class="container">
                <ScreenCaption goback={this.props.goback} args={this.props.args} caption={"Тип события"}/>
                <div class="row mt-5">
                    <div class="col-md-6">
                        <form>
                            <div class="form-group">
                                <label for="name"> Тип:</label>
                                <input type="text" class="form-control w-100" id="name" value={this.state.currentEventType.name} onChange={this.handleChangeName} />
                                <label for="description">Описание:</label>
                                <input type="text" class="form-control w-100" id="description"  value={this.state.currentEventType.description} onChange={this.handleChangeDescription} />
                            </div>
                        </form>
                    </div>
                    <div class="col-md-3 offset-3">
                        <div class="row mt-3">
                            <button class="btn btn-primary w-100" onClick={this.save}>Сохранить</button>   
                        </div>
                    </div>
                </div>
            </div> 
        )
    }

}


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/event/event-type.js